import { TabOrientations } from '@components/Tabs/types';
import { TabPanelVariants } from '@primitives/TabPanel/types';

export const TAB_DEFAULT_VARIANT: TabPanelVariants = 'underline';

export const TAB_DEFAULT_ORIENTATION: TabOrientations = 'horizontal';
